<template>
  <v-card flat>
    <v-card-text class="pa-0">
      <template>
        <v-tabs
          grow
          v-model="tab"
          background-color="grey lighten-4"
          active-class="font-weight-bold"
        >
          <v-tab>Pendentes </v-tab>
          <v-tab>Finalizadas</v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab">
          <v-tab-item>
            <lista-solicitacoes-plano-saude
              :listaSolics="getListaSolics(false)"
            />
          </v-tab-item>
          <v-tab-item>
            <lista-solicitacoes-plano-saude
              :listaSolics="getListaSolics(true)"
            />
          </v-tab-item>
        </v-tabs-items>
      </template>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapState } from "vuex";
import ListaSolicitacoesPlanoSaude from "../lists/ListaSolicitacoesPlanoSaude.vue";
export default {
  components: { ListaSolicitacoesPlanoSaude },
  computed: mapState("planoSaude", ["solicitacoes"]),
  data: () => ({
    tab: 0,
  }),
  methods: {
    getListaSolics(value) {
      return this.solicitacoes.filter((s) => s.status_final == value);
    },
  },
};
</script>

<style>
</style>